import {
  IconBook,
  IconUsers,
  IconTimeline,
  IconDiscount2,
  IconSchool,
  IconLicense,
  IconMail,
  IconReceipt,
  IconBuildingBank,
  IconKeyboard,
  IconVideo,
  IconNews,
  IconThumbUp,
  IconPackage,
  IconShoppingCart,
  IconDeviceGamepad2,
} from "@tabler/icons";

const icons = {
  IconBook,
  IconUsers,
  IconTimeline,
  IconDiscount2,
  IconSchool,
  IconLicense,
  IconMail,
  IconReceipt,
  IconBuildingBank,
  IconKeyboard,
  IconVideo,
  IconNews,
  IconThumbUp,
  IconPackage,
  IconShoppingCart,
  IconDeviceGamepad2,
};

const smarttyping = {
  id: "smarttyping-ops",
  title: "การดำเนินงาน",
  type: "group",
  children: [
    {
      id: "courses-manage",
      title: "คอร์สเรียน",
      type: "item",
      url: "/courses/manage",
      icon: icons.IconBook,
    },
    {
      id: "courses-bundles",
      title: "แพ็กรวมคอร์ส",
      type: "item",
      url: "/courses/bundles",
      icon: icons.IconPackage,
    },
    {
      id: "students-insights",
      title: "นักเรียน",
      type: "item",
      url: "/students/insights",
      icon: icons.IconUsers,
    },
    {
      id: "practice-passages",
      title: "ข้อความฝึกพิมพ์",
      type: "item",
      url: "/practice-passages",
      icon: icons.IconKeyboard,
    },
    {
      id: "articles",
      title: "บทความ",
      type: "item",
      url: "/articles",
      icon: icons.IconNews,
    },
    {
      id: "shop",
      title: "อุปกรณ์แนะนำ (ร้านค้า)",
      type: "item",
      url: "/shop",
      icon: icons.IconShoppingCart,
    },
    {
      id: "hero-video",
      title: "วิดีโอหน้าแรก",
      type: "item",
      url: "/site/hero-video",
      icon: icons.IconVideo,
    },
    {
      id: "review-post",
      title: "โพสรีวิว",
      type: "item",
      url: "/site/review-post",
      icon: icons.IconThumbUp,
    },
    {
      id: "snooky-balance",
      title: "ปรับความยาก Snooky Key",
      type: "item",
      url: "/site/snooky-balance",
      icon: icons.IconDeviceGamepad2,
    },
    {
      id: "courses-coupons",
      title: "คูปองส่วนลด",
      type: "item",
      url: "/courses/coupons",
      icon: icons.IconDiscount2,
    },
    {
      id: "payment-transfers",
      title: "ตรวจสลิปโอนเงิน",
      type: "item",
      url: "/payments/transfers",
      icon: icons.IconReceipt,
    },
    {
      id: "bank-accounts",
      title: "บัญชีรับเงิน",
      type: "item",
      url: "/payments/bank-accounts",
      icon: icons.IconBuildingBank,
      roles: ["superadmin"],
    },
    {
      id: "contact-inquiries",
      title: "ข้อความติดต่อ",
      type: "item",
      url: "/contact-inquiries",
      icon: icons.IconMail,
    },
    {
      id: "cohorts-pipeline",
      title: "รุ่นเรียน (Cohort)",
      type: "item",
      url: "/cohorts/pipeline",
      icon: icons.IconTimeline,
    },
    {
      id: "schools-tenants",
      title: "โรงเรียนในระบบ",
      type: "item",
      url: "/schools/tenants",
      icon: icons.IconSchool,
      roles: ["superadmin"],
    },
    {
      id: "schools-subscriptions",
      title: "แพ็กเกจสมาชิก",
      type: "item",
      url: "/schools/subscriptions",
      icon: icons.IconLicense,
      roles: ["superadmin"],
    },
  ],
};

export default smarttyping;
